import { render, staticRenderFns } from "./SupplierRawMaterialSolvents.vue?vue&type=template&id=d5973cee&scoped=true&"
import script from "./SupplierRawMaterialSolvents.vue?vue&type=script&lang=js&"
export * from "./SupplierRawMaterialSolvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5973cee",
  null
  
)

export default component.exports